/**
 * @fileoverview A few easing shapes can't render if they get null
 * data. This can also hose the dev tools with SVG warnings.
 */

const IS_DEV = process.env.NODE_ENV === 'development'
const CAN_LOG = IS_DEV && typeof console !== 'undefined' && 'group' in console

export function guardProps(component, ...keys) {
  let invalid = keys.filter(key => {
    let value = component.props[key]

    return value == null || isNaN(value)
  })

  if (invalid.length > 0 && CAN_LOG) {
    let name = component.constructor.name || 'Easing shape'
    let tag = `Invalid ${name}`

    console.group(tag)
    invalid.forEach(function(key) {
      console.error('%s:%s', key, component.props[key])
    })
    console.groupEnd(tag)
  }

  return invalid.length > 0
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/validate.js